import React, {useEffect, useState,useRef } from 'react';
import ResponsiveBox, {Row, Col, Item, Location} from 'devextreme-react/responsive-box';
import { useScreenSize } from '../../utils/media-query';
import Menu from 'devextreme-react/menu';
import trMessages from "devextreme/localization/messages/tr.json";
import { formatMessage, loadMessages, locale } from 'devextreme/localization';
import DropDownButton from 'devextreme-react/drop-down-button';
import NavLink from 'react-router-dom/NavLink';
import one from '../../assets/connect-your-store.jpeg';
import two from '../../assets/print-packing-slip.jpeg';
import three from '../../assets/send-your-package.jpeg';
import four from '../../assets/happy-customer.jpeg';
import serviceList from '../../utils/shipsland-service-list';
import serviceListTR from '../../utils/shipsland-service-list-tr';
import dictionary from '../../utils/dictionary';
import shipslandLogo from '../../assets/shipsland.png';
import Form, {SimpleItem, ButtonItem, ButtonOptions} from 'devextreme-react/form';
import Drawer from 'devextreme-react/drawer';
import Toolbar from 'devextreme-react/toolbar';
import appInfo from '../../app-info';
import './landing-page.scss';

function screen(width) {
    return (width < 700)? 'sm': 'lg';
}

const LandingPage = (props) => {
    const [offset, setOffset] = useState(0);
    const [lang,setLang] = useState(navigator.language==='tr'?'tr':'en');
    const { isSmall,isXSmall } = useScreenSize();
    let pricesRef = useRef();
    let contactUsRef = useRef();
    let trInternationalExpressRef = useRef();
    let trInternationalEcoRef = useRef();
    let trEUDPPRef = useRef();
    let trUSALessContainerLoadRef = useRef();
    let chinaInternationalExpressRef = useRef();
    let chinaTrexpressRef = useRef();
    let chinaInternationalEco = useRef();
    let usaDomesticLTLRef = useRef();
    let usaTrSmallPackageRef = useRef();
    let usaDomesticSmallPackageRef = useRef();
    let usaWarehouseRef = useRef();
    let chinaWarehouseRef = useRef();
    let germanyWarehouseRef = useRef();
    let turkeyWarehouseRef = useRef();

    useEffect(() => {
        locale(lang);
        loadMessages(trMessages);
        loadMessages(dictionary.getDictionary());
        window.onscroll = () => {
          setOffset(window.pageYOffset)
        }
    }, [lang]);

    const langOnClick = ({itemData}) =>{
        setLang(itemData);
    }

    const menuItemOnClick = ({itemData}) =>{
        if(itemData.name !=='Services'){
            if(itemData.name === 'Prices'||itemData.name === 'Fiyat')
                window.scrollTo(0, pricesRef.current.offsetTop-100);
            else if(itemData.name === 'Contact Us'||itemData.name ==='Bizimle iletişime')
                window.scrollTo(0, contactUsRef.current.offsetTop-100);
            else if(itemData.name === 'TR-International Express'||itemData.name === 'TR-Uluslararası Ekspres')
                window.scrollTo(0, trInternationalExpressRef.current.offsetTop-100);
            else if(itemData.name === 'TR-International Eco (Small Package)'||itemData.name === 'TR-Uluslararası Eko (Küçük Paket)')
                window.scrollTo(0, trInternationalEcoRef.current.offsetTop-100);
            else if(itemData.name === 'TR-EU (DDP)')
                window.scrollTo(0, trEUDPPRef.current.offsetTop-100);
            else if(itemData.name === 'TR-USA Less Container Load (DDP)'||itemData.name === 'TR-USA Daha Az Konteyner Yükü (DDP)')
                window.scrollTo(0, trUSALessContainerLoadRef.current.offsetTop-100);
            else if(itemData.name === 'China-International Express'||itemData.name === 'Çin-Uluslararası Ekspres')
                window.scrollTo(0, chinaInternationalExpressRef.current.offsetTop-100);
            else if(itemData.name === 'Small Package (DDP)'||
                    itemData.name === 'Sample (DDP)'||
                    itemData.name === 'Express (DDP)'||
                    itemData.name === 'Küçük Paket (DDP)'||
                    itemData.name === 'Örnek (DDP)'||
                    itemData.name === 'Ekspres (DDP)'
                )
                window.scrollTo(0, chinaTrexpressRef.current.offsetTop-100);
            else if(itemData.name === 'China-International Eco (Small Package)'||itemData.name === 'Çin-Uluslararası Eko (Küçük Paket)')
                window.scrollTo(0, chinaInternationalEco.current.offsetTop-100);
            else if(itemData.name === 'USA Domestic (LTL)'|| itemData.name === 'ABD Yurtiçi (LTL)')
                window.scrollTo(0, usaDomesticLTLRef.current.offsetTop-100);
            else if(itemData.name === 'USA-Turkey (Small Package / DDP)'|| itemData.name === 'ABD-Türkiye (Küçük Paket / DDP)')
                window.scrollTo(0, usaTrSmallPackageRef.current.offsetTop-100);
            else if(itemData.name === 'USA Domestic (Small Package)'||itemData.name === 'ABD Yurtiçi (Küçük Paket)')
                window.scrollTo(0, usaDomesticSmallPackageRef.current.offsetTop-100);
            else if(itemData.name === 'USA International'||itemData.name === 'ABD Uluslararası')
                window.scrollTo(0, usaDomesticSmallPackageRef.current.offsetTop-100);
            else if(itemData.name === 'USA Warehouse'|| itemData.name === 'ABD Depo')
                window.scrollTo(0, usaWarehouseRef.current.offsetTop-100);
            else if(itemData.name === 'China Warehouse'||itemData.name === 'Çin Depo')
                window.scrollTo(0, chinaWarehouseRef.current.offsetTop-100);
            else if(itemData.name === 'Germany Warehouse'||itemData.name === 'Almanya Depo')
                window.scrollTo(0, germanyWarehouseRef.current.offsetTop-100);
            else if(itemData.name === 'Turkey Warehouse'||itemData.name === 'Türkiye Depo')
                window.scrollTo(0, turkeyWarehouseRef.current.offsetTop-100);
        }   
    }
    const dpButton = (data) =>{
        return(
            <div style={{'textTransform':'upperCase'}}>
                {data}
            </div>
        )
    }

    return (
        <div id={"landing-page"} className="landing-page">
            <ResponsiveBox singleColumnScreen="sm" screenByWidth={screen}>
                <Row ratio={1}></Row>
                <Row ratio={1} screen="xs"></Row>
                <Row ratio={1}></Row> 
                <Row ratio={1}></Row>
                <Row ratio={2}></Row>
                <Row ratio={1}></Row>
                <Row ratio={1}></Row>
                <Row ratio={1}></Row>
                <Row ratio={1}></Row>
                <Row ratio={1}></Row>
                <Row ratio={1}></Row>
                <Col ratio={1}></Col>
                <Col ratio={1}></Col>
                <Item>
                    <Location row={0} col={0} colspan={3} screen="lg"></Location>
                    <Location row={0} col={0} colspan={2} screen="sm"></Location>
                    <div className={offset>50?"landing-nav-after-scroll":"landing-nav"}>
                        <ul className="nav">
                            <div className="left-nav">
                                <li>
                                    <NavLink className="brand" to="/" activeClassName="navlink-active">
                                        <h1>{appInfo.title}</h1>
                                    </NavLink>
                                </li>             
                                </div>
                                <div className="right-nav">
                                    <Menu
                                        items={lang==='en'?serviceList:serviceListTR}
                                        displayExpr="name"
                                        onItemClick={menuItemOnClick}
                                    />
                                    <DropDownButton
                                        className={'last-left-link'}
                                        stylingMode={'text'}
                                        itemRender={dpButton}
                                        text={lang.toUpperCase()}
                                        dropDownOptions={{ width: '4vw' }}
                                        items={['en','tr']}
                                        onItemClick={(e)=>{langOnClick(e)}}
                                    />
                                    <li>
                                        <NavLink className="link" to="/Login" activeClassName="navlink-active">{lang==='en'?"Login":"Giriş Yap"}</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="link" to="/create-account" activeClassName="navlink-active">{lang==='en'?"Signup":"Üye Ol"}</NavLink>
                                    </li>
                                </div>
                        </ul>
                    </div>
                </Item>
                <Item>
                    <Location row={1} col={0} colspan={3} screen="lg"></Location>
                    <Location row={1} col={0} colspan={2} screen="sm"></Location>
                    <div className={'section-1'}>
                            <img alt={'shipsland-logo'} className={'section-1-logo-middle'} src={shipslandLogo}/>
                            <h2 className={'section-1-title'}>{formatMessage("Experienced Specialist")}</h2>
                            <p className={'section-1-subtitle'}>{formatMessage('HELP SHIP YOUR PACKAGES FASTER')}</p>
                            <p className={'section-1-description'}>{formatMessage('ShipsLand is web application which gives services to e-commerce marketplace sellers. Our application enables e-commerce marketplace sellers to manage all their orders from all platforms just in one screen and easily create shipping labels for your orders. Our application takes care of all the boring details and give you a simple and clean work environment to handle all your orders. We are taking our business to the next level and working on our fulfillment center project.')}</p>
                    </div>
                </Item>
                <Item>
                    <Location row={2} col={0} colspan={3} screen="lg"></Location>
                    <Location row={2} col={0} colspan={2} screen="sm"></Location>
                    <div className="section-2">
                        <h2 className={'section-title'}>{formatMessage("How it Works")}</h2>
                    </div>
                </Item>
                <Item>
                    <Location row={3} col={0} screen="lg"></Location>
                    <Location row={3} col={0} screen="sm"></Location>
                    <div id="section-2" className="section-2">
                        <div className={'section-2-list'}>
                            <div id={'section-2-one'}>
                                <div className={'section-2-container'}>
                                    <img className={'section-2-img'} alt={'connect-your-store'} src={one} />
                                    <h4 className={'section-2-subtitle'}>{formatMessage("Connect Your Store")}</h4>
                                    <p className={'section-2-description'}>{formatMessage("Connect your stores in all market place with our single integration")}</p>
                                </div>
                            </div>
                            <div id={'section-2-two'}>
                                <div className={'section-2-container'}>
                                    <img className={'section-2-img'} alt={'print-your-packing-slip'} src={two} />
                                    <h4 className={'section-2-subtitle'}>{formatMessage("Print Packing Slip")}</h4>
                                    <p className={'section-2-description'}>{formatMessage("Print packing slip for your upcoming shipments and get the best rate for label")}</p>
                                </div>
                            </div> 
                        </div>
                    </div>
                </Item>
                <Item>
                    <Location row={3} col={1} screen="lg"></Location>
                    <Location row={3} col={1} screen="sm"></Location>
                    <div id="section-2-list" className="section-2">
                        <div className={'section-2-list'}>
                            <div id={'section-2-three'}>
                                <div className={'section-2-container'}>
                                    <img className={'section-2-img'} alt={'send-your-package'} src={three} />
                                    <h4 className={'section-2-subtitle'}>{formatMessage("Send Your Package")}</h4>
                                    <p className={'section-2-description'}>{formatMessage("Send your package to us and we will prepare the shipment for you")}</p>
                                </div>
                            </div>
                            <div id={'section-2-four'}>
                                <div className={'section-2-container'}>
                                    <img  className={'section-2-img'} alt={'happy-customer'} src={four}/>
                                    <h4 className={'section-2-subtitle'}>{formatMessage("Happy Customer")}</h4>
                                    <p className={'section-2-description'}>{formatMessage("Package will arrive to your customer safely")}</p>  
                                </div>
                            </div>
                        </div>
                    </div>
                </Item>
                <Item>
                    <Location row={4} col={0} colspan={3} screen="lg"></Location>
                    <Location row={4} col={0} colspan={2} screen="sm"></Location>
                    <div className={'section-3'}>
                        <h2 className={'section-title'}>{formatMessage('Services')}</h2>
                    </div>
                </Item>
                <Item>
                    <Location row={5} col={0}  colspan={2} screen="lg"></Location>
                    <Location row={5} col={0} screen="sm"></Location>
                    <div id="service-list" className={'section-3'}>
                        <h4 className={'service-sublist'}>A. {formatMessage('LOGISTICS')}</h4>
                        <h4 className={'service-sublist2'}>1. {formatMessage('TURKEY-INTERNATIONAL')}</h4>
                        <div ref={trInternationalExpressRef} className={'service-description'}>
                            <span className={'logistic-list'}>a. {formatMessage('TR-INTERNATIONAL EXPRESS')}</span>
                            <br/>
                            <p>{formatMessage('You can send your shipments with TURKEY - INTERNATIONAL EXPRESS service to 220 countries and AMAZON FBA warehouses from Turkey with our logistics solution partners such as UPS, FedEx, TNT, and DHL. EKSPRESS SHIPPING advantage; our service enables shipments not exceeding 15.000€ and 300kg weight to be sent with ETGB (Electronic Trade Customs Declaration) without the need for air transport and customs consultancy service.')}</p>
                        </div>
                        <div ref={trInternationalEcoRef} className={'service-description'}>
                            <span className={'logistic-list'}>b. {formatMessage('TR-INTERNATIONAL ECO (SMALL PACKAGE)')}</span>
                            <br/>
                            <p>{formatMessage('TURKEY - INTERNATIONAL ECO SMALL PACKAGE service offers price advantages for your fast and affordable small package shipments from Turkey to the world as an alternative to PTT service. By being integrated into our system, you can instantly create labels for your eco packages, get a tracking number, and save time by printing your own labels.')}</p>
                        </div>
                        <div ref={trEUDPPRef} className={'service-description'}>
                            <span className={'logistic-list'}>c. {formatMessage('TR - EU DDP')}</span>
                            <br/>
                            <p>{formatMessage('The advantage of your TURKEY - EUROPE ECO shipments is that we do it on your behalf without having to create a separate ATR document for each shipment, and within the scope of the customs union agreement with the European Union, we deliver your commercial goods door-to-door, paying only VAT, without tax. In addition, we prepare your shipments with ETGB (Electronic Trade Customs Declaration) and perform all procedures on your behalf.')}
                            </p>
                            <p>{formatMessage('Advantages')}:
                                <ul className="checkmark">
                                    <li>{formatMessage('Your shipments under 22€ will be delivered door-to-door without any problem.')}</li>
                                    <li>{formatMessage('We handle all transactions for your commercial shipments on your behalf.')}</li>
                                    <li>{formatMessage('We send AMAZON FBA warehouses on your behalf without the need for a company.')}</li>
                                    <li>{formatMessage("In case of customs tax on your shipments, we will make the payment on your behalf. This way, you don't have to deal with customs procedures.")}</li>
                                </ul>
                            </p>
                        </div>  
                        <div ref={trUSALessContainerLoadRef} className={'service-description'}>
                            <span className={'logistic-list'}>d. {formatMessage('TR-USA LESS CONTAINER LOAD DDP')}</span>
                            <br/>
                            <p>{formatMessage('Increasing freight costs due to air cargo and express cargo reveal the need for alternative services. With our TURKEY - USA LESS CONTAINER LOAD service, we carry out all the customs procedures of your cargo located in Turkey on your behalf, and ship them from Turkey to USA, to our warehouses, to different locations  or to AMAZON FBA warehouses. It reaches USA in about 30 days with our regular container exits every month.')}</p>
                            <p><b>{formatMessage('How does it work?')}</b></p>
                            <p>{formatMessage('Within the scope of this service, you enter the content and delivery address of the commercial cargo you will send from Turkey to USA via our application. We work in line with the information you have provided and calculate the customs tariff and freight cost for you and offer door-to-door delivery service.')}
                            </p>
                        </div>
                        <h4 className={'service-sublist2'}>2. {formatMessage('CHINA-INTERNATIONAL')}</h4>
                        <div ref={chinaInternationalExpressRef} className={'service-description'}>
                            <span className={'logistic-list'}> a. {formatMessage('CHINA-INTERNATIONAL EXPRESS')}</span>
                            <br/>
                            <p>{formatMessage('With CHINA - INTERNATIONAL EXPRESS service, you can send your shipments from China to 220 countries and AMAZON FBA warehouses with our logistics solution partners such as UPS, FedEx, TNT and DHL. We organize all your loads in China on your behalf.')}
                            </p>
                        </div>
                        <div ref={chinaTrexpressRef} className={'service-description'}>
                            <span className={'logistic-list'}> b. {formatMessage('CHINA-TURKEY EXPRESS')}</span>
                            <br/>
                            <p>{formatMessage('We carry out the customs procedures of your products coming from China to Turkey faster than the global logistics brands such as DHL, UPS and FedEx on your behalf and deliver them. Within the scope of this service')}:</p>
                            <p>
                            <ul>
                                <li>1. {formatMessage('We carry out the customs clearance of your individual products purchased from China faster and more economically than PTT on your behalf and deliver them to your address with prices starting from $5 by ARAS cargo. The customs tax is up to 30% of the product you purchase, and if you make your payment, you can receive your product without any problems. For example, if a headphone you buy is $10, by paying $5 shipping fee and $3 customs tax which is total of $8, we handle your procedures on your behalf without any problems.')}</li>
                                <li>2. {formatMessage('For the samples you bring on behalf of the company, customs and cargo processes are often extremely difficult. With the ShipsLand EXSPRESS service, we prepare the sample cargo you send to our warehouse in China on your behalf and deliver it to you in approx. 7 days.')}</li>
                            </ul>
                            </p>
                        </div>
                        <div ref={chinaInternationalEco} className={'service-description'}>
                            <span className={'logistic-list'}> c. {formatMessage('CHINA-INTERNATIONAL ECO')}</span>
                            <br/>
                            <p>{formatMessage('Within the scope of our CHINA INTERNATIONAL SMALL PACKAGE service, you can now easily perform your e-commerce shipments with the integration of our application. With our application, you can create a label as you wish or you can send your products that we fulfill on your behalf in our China warehouse to your customers. Now, 360 degree e-commerce is very easy with ShipsLand!')}</p>
                            <p></p>
                        </div>
                        <div ref={usaDomesticLTLRef} className={'service-description'}>
                            <h4 className={'service-sublist2'}>3. {formatMessage('USA-INTERNATIONAL')}</h4>
                            <span className={'logistic-list'}> a. {formatMessage('USA-DOMESTIC LTL')}</span>
                            <br/>
                            <p>{formatMessage('COMING SOON…')}</p>
                        </div>
                        <div ref={usaTrSmallPackageRef} className={'service-description'}>
                            <span className={'logistic-list'}> b. {formatMessage('USA-TURKEY SMALL PACKAGE')}</span>
                            <br/>
                            <p>{formatMessage('COMING SOON…')}</p>
                        </div>
                        <div ref={usaDomesticSmallPackageRef} className={'service-description'}>
                            <span className={'logistic-list'}> c. {formatMessage('USA DOMESTIC')}</span>
                            <br/>
                            <p>{formatMessage('With our USA DOMESTIC CARGO service, you can easily send cargo from any address you want or from our warehouse. We deliver your shipments on your behalf from our warehouse in the USA where we partners UPS, FedEx or USPS.')}</p>
                        </div>
                        <h4 className={'service-sublist'}>B. {formatMessage('FULFILLMENT')}</h4>
                        <h4 ref={usaWarehouseRef} className={'service-sublist2'}>1. {formatMessage('USA WAREHOUSE')}</h4>
                        <div className={'service-description'}>
                            <p>{formatMessage('In our warehouse located in the state of NEW JERSEY / USA, we provide all the services needed by our e-commerce customers such as product storage, stocking, inventory taking, AMAZON FBA labeling and return operations. We provide all the services you want such as intermediate warehouse, stocking warehouse or delivering your products to any point in the world on your behalf. Please contact us for detailed information.')}</p>
                        </div>
                        <h4 ref={chinaWarehouseRef} className={'service-sublist2'}>2. {formatMessage('CHINA WAREHOUSE')}</h4>
                        <div className={'service-description'}>
                            <p>{formatMessage('In our warehouse located in GUANGZHOU / CHINA, we provide all the services needed by our e-commerce customers such as product storage, stocking, inventory taking, AMAZON FBA labeling and return operations. We provide all the services you want such as intermediate warehouse, stocking warehouse or delivering your products to any point in the world on your behalf. Please contact us for detailed information.')}</p>
                        </div>
                        <h4 ref={germanyWarehouseRef} className={'service-sublist2'}>3. {formatMessage('GERMANY WAREHOUSE')}</h4>
                        <div className={'service-description'}>
                            <p>{formatMessage('COMING SOON…')}</p>
                        </div>
                        <h4 ref={turkeyWarehouseRef} className={'service-sublist2'}>4. {formatMessage('TURKEY WAREHOUSE')}</h4>
                        <div className={'service-description'}>
                            <p>{formatMessage('In our warehouse located in ISTANBUL / TURKEY, we provide all the services needed by our e-commerce customers such as product storage, stocking, inventory taking, AMAZON FBA labeling and return operations. We provide all the services you want such as intermediate warehouse, stocking warehouse or delivering your products to any point in the world on your behalf. Please contact us for detailed information.')}</p>
                        </div>
                    </div>
              </Item>
                <Item>
                    <Location row={6} col={0} colspan={3} screen="lg"></Location>
                    <Location row={6} col={0} colspan={2} screen="sm"></Location>
                    <div id={'prices'} ref={pricesRef} className="section-2">
                        <h2 className={'section-title'}>{formatMessage("Prices")}</h2>
                        <p style={{'fontWeight':'bold','textAlign':'center'}}>{formatMessage('COMING SOON…')}</p>
                    </div>
                </Item>
                <Item>
                    <Location row={7} col={0} colspan={3} screen="lg"></Location>
                    <Location row={7} col={0} colspan={2} screen="sm"></Location>
                    <div ref={contactUsRef} className={'section-4'}>
                        <h2>{formatMessage('Drop Us a Line')}</h2>
                        <p>{formatMessage('WHAT DO YOU THINK ABOUT OUR SERVICES')}</p>
                        <form action={`mailto:support@shipsland.com`}>
                        <Form className={'section-4-form'}>
                            <SimpleItem
                            dataField={formatMessage('name')}
                            />
                             <SimpleItem
                            dataField={formatMessage('email')}
                            />
                             <SimpleItem
                            dataField={formatMessage('message')}
                            editorType="dxTextArea"
                            editorOptions={{
                                height: 90
                            }}
                            />
                             <ButtonItem>
                                <ButtonOptions
                                    text={formatMessage('Send Email')}
                                    stylingMode={'outlined'}
                                    horizontalAlignment={'center'}
                                    useSubmitBehavior={true}
                                >
                            </ButtonOptions>
                            </ButtonItem>
                        </Form>
                        </form>
                    </div>
                </Item>
                <Item>
                    <Location row={8} col={0} screen="lg"></Location>
                    <Location row={8} col={0} screen="sm"></Location>
                    <div id={'section-3'} className="left-side-bar item">
                        <div className={'section-3-description'}>
                            <h2>{formatMessage("Our Locations")}</h2>
                            <p>
                            {formatMessage("Place your products into our warehouses located in US, Turkey, China, and Germany(Coming Soon) and ship the orders faster and easier with our APIs Integration.")}
                            </p>
                        </div>
                    </div>
                </Item>
                 <Item>
                    <Location row={8} col={1} colspan={2} screen="lg"></Location>
                    <Location row={8} col={1} screen="sm"></Location>
                    <div className="right-side-bar item">
                    </div>
                </Item>
                <Item>
                    <Location row={9} col={0} colspan={3} screen="lg"></Location>
                    <Location row={9} col={0} colspan={2} screen="sm"></Location>
                    <div className="footer item">
                        <div className="footer-1 m_2">
                            <h4 className={'footer-title'}>{appInfo.title}</h4>
                            <p className={'mb-2'}><i className="fas fa-map-pin" style={{color: 'white'}}></i> {appInfo.address}</p>
                            <p className={'mb-2'}><i className="fas fa-map-pin" style={{color: 'white'}}></i> {appInfo.address1}</p>
                            <p className={'mb-2'}><i className="fas fa-map-pin" style={{color: 'white'}}></i> {appInfo.address2}</p>
                        </div>
                        <div className="footer-2 m_2">
                            <p>{formatMessage('ABOUT')}</p>
                            <hr className={'mb-2'}/>
                            <li><NavLink className={'link'} to ="/about-us">{formatMessage('About Us')}</NavLink></li>
                            <li><NavLink className={'link'} to ="/legal/terms-of-service">{formatMessage('Terms Of Service')}</NavLink></li>
                            <li><NavLink className={'link'} to ="/legal/privacy-policy">{formatMessage('Privacy Policy')}</NavLink></li>
                        </div>
                        <div className="footer-2 m_2">
                            <p>{formatMessage('PARTNERS')}</p>
                            <hr className={'mb-2'}/>
                            <li>{formatMessage('Technology Partners')}</li>
                            <li>{formatMessage('Carrier Partners')}</li>
                            <li>{formatMessage('Market Place Partners')}</li>
                        </div>
                    </div>
                    <div className={'disclaimer'}>2020 | &copy; {appInfo.company} | {formatMessage('all right reserved')}</div>
                </Item>
            </ResponsiveBox>
        </div>
    )
}
export default LandingPage;